// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/202610081405/js/" + chunkId + "." + {"44":"284850ee","225":"846fe995","481":"346d04e5","486":"028030b9","770":"72dde755"}[chunkId] + ".0.8078855437135384.chunk.js";
};